import { CONFIG } from './config';

// Runtime config: reads from localStorage, falls back to config.js
export function getGlobal() {
  try { return { ...CONFIG, ...JSON.parse(localStorage.getItem('omni_global') || '{}') }; }
  catch { return CONFIG; }
}

export function getCompanyConfig(companyId) {
  try { return JSON.parse(localStorage.getItem('omni_company_' + companyId) || '{}'); }
  catch { return {}; }
}



// ─── EVOLUTION API ───────────────────────────────────────────────────────────

export const evolutionAPI = {
  // Enviar mensagem de texto
  async sendText(instance, number, text) {
    const res = await fetch(`${CONFIG.EVOLUTION_BASE}/message/sendText/${instance}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': CONFIG.EVOLUTION_KEY,
      },
      body: JSON.stringify({ number, text }),
    });
    return res.json();
  },

  // Enviar mídia (imagem/vídeo + legenda)
  async sendMedia(instance, number, mediaUrl, caption, mediatype = 'image') {
    const res = await fetch(`${CONFIG.EVOLUTION_BASE}/message/sendMedia/${instance}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': CONFIG.EVOLUTION_KEY,
      },
      body: JSON.stringify({
        number,
        mediatype,
        media: mediaUrl,
        caption,
        fileName: 'media.jpg',
        mimetype: mediatype === 'image' ? 'image/jpeg' : 'video/mp4',
      }),
    });
    return res.json();
  },

  // Listar instâncias conectadas
  async listInstances() {
    const res = await fetch(`${CONFIG.EVOLUTION_BASE}/instance/fetchInstances`, {
      headers: { 'apikey': CONFIG.EVOLUTION_KEY },
    });
    return res.json();
  },
};

// ─── N8N API ─────────────────────────────────────────────────────────────────

export const n8nAPI = {
  // Acionar workflow por webhook (disparo em massa)
  async triggerWebhook(webhookPath, payload) {
    const res = await fetch(`${CONFIG.N8N_BASE}/webhook/${webhookPath}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  // Ativar/pausar workflow
  async setWorkflowActive(workflowId, active) {
    const res = await fetch(`${CONFIG.N8N_BASE}/api/v1/workflows/${workflowId}/${active ? 'activate' : 'deactivate'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-N8N-API-KEY': CONFIG.N8N_API_KEY,
      },
    });
    return res.json();
  },

  // Listar execuções recentes
  async getExecutions(workflowId, limit = 20) {
    const res = await fetch(
      `${CONFIG.N8N_BASE}/api/v1/executions?workflowId=${workflowId}&limit=${limit}`,
      { headers: { 'X-N8N-API-KEY': CONFIG.N8N_API_KEY } }
    );
    return res.json();
  },

  // Atualizar Code Node com variações de mensagem
  // Esta é a integração chave: injeta as variações do app no fluxo
  async updateMessageVariations(workflowId, variations, mediaUrl = null, caption = null, isMediaFlow = false) {
    // Gera o jsCode com as variações
    const variationsArray = variations.map(v => `\`${v.replace(/`/g, "'")}\``).join(',\n  ');

    let jsCode;
    if (isMediaFlow) {
      jsCode = `
const nome = $json.NOME || $json.data?.NOME || '';
if (!nome) throw new Error('Nome não encontrado!');

const mensagens = [
  ${variationsArray}
];

const idx = Math.floor(Math.random() * mensagens.length);
return {
  Nome: nome,
  Whatsapp: $json.WHATSAPP || $json.data?.WHATSAPP || '',
  Mensagem: mensagens[idx],
  MediaUrl: '${mediaUrl || ''}',
  Caption: \`${(caption || '').replace(/`/g, "'")}\`,
};`;
    } else {
      jsCode = `
const nome = $json.NOME || $json.data?.NOME || '';
if (!nome) throw new Error('Nome não encontrado!');

const mensagens = [
  ${variationsArray}
];

const idx = Math.floor(Math.random() * mensagens.length);
return {
  Nome: nome,
  Whatsapp: $json.WHATSAPP || $json.data?.WHATSAPP || '',
  Mensagem: mensagens[idx],
};`;
    }

    // Busca workflow atual
    const wfRes = await fetch(`${CONFIG.N8N_BASE}/api/v1/workflows/${workflowId}`, {
      headers: { 'X-N8N-API-KEY': CONFIG.N8N_API_KEY },
    });
    const workflow = await wfRes.json();

    // Atualiza o node "Mensagem"
    const updatedNodes = workflow.nodes.map(node => {
      if (node.name === 'Mensagem') {
        return { ...node, parameters: { ...node.parameters, jsCode } };
      }
      return node;
    });

    // Salva workflow atualizado
    const saveRes = await fetch(`${CONFIG.N8N_BASE}/api/v1/workflows/${workflowId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-N8N-API-KEY': CONFIG.N8N_API_KEY,
      },
      body: JSON.stringify({ ...workflow, nodes: updatedNodes }),
    });
    return saveRes.json();
  },
};

// ─── TOGGLE AGENTE (Redis via webhook n8n) ───────────────────────────────────

export const agentAPI = {
  async toggle(sessionId, active) {
    // Chama webhook n8n que seta/deleta flag Redis block:{sessionId}
    const res = await fetch(CONFIG.REDIS_TOGGLE_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, block: !active }),
    });
    return res.json();
  },
};

// ─── CLOUDINARY UPLOAD (assinado — API Key + Secret) ─────────────────────────

const CLOUDINARY_CLOUD = 'dcnqucc4s';
const CLOUDINARY_API_KEY = '644398599545662';
const CLOUDINARY_API_SECRET = 'TyNj7ISD4pdHf50HjUSNa_C-REo';

// Gera assinatura SHA-1 para upload assinado
async function cloudinarySign(params) {
  const sorted = Object.keys(params).sort()
    .map(k => `${k}=${params[k]}`)
    .join('&') + CLOUDINARY_API_SECRET;

  const msgBuffer = new TextEncoder().encode(sorted);
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export const cloudinaryAPI = {
  async upload(file) {
    const timestamp = Math.round(Date.now() / 1000);
    const folder = 'omni_uploads';

    const signature = await cloudinarySign({ folder, timestamp });

    const fd = new FormData();
    fd.append('file', file);
    fd.append('api_key', CLOUDINARY_API_KEY);
    fd.append('timestamp', timestamp);
    fd.append('folder', folder);
    fd.append('signature', signature);

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/auto/upload`,
      { method: 'POST', body: fd }
    );
    const data = await res.json();
    if (data.error) throw new Error(data.error.message);
    return data.secure_url;
  },
};

// ─── GERADOR DE VARIAÇÕES (OpenAI via n8n ou local) ─────────────────────────
// Lógica replicada do seu fluxo: gera 5 variações com openers/closers diferentes

export function generateVariations(template, agentName = 'Sofia') {
  const openers = ['Oi', 'Olá', 'E aí', 'Boa tarde', 'Oiê'];
  const closers = [
    'Posso te ajudar com mais detalhes? 😊',
    'Estou à disposição!',
    'Qualquer dúvida é só falar.',
    'Me conta mais sobre sua situação.',
    'Quando quiser avançar, é só falar 🚀',
  ];

  return openers.map((opener, i) => {
    let v = template;
    // Substitui saudação inicial se houver
    v = v.replace(/^(Oi|Olá|E aí|Boa tarde|Oiê)[,!]?/i, opener + ',');
    // Adiciona closer se não tiver pergunta no final
    if (!v.trim().endsWith('?')) {
      v = v.trim() + '\n\n' + closers[i];
    }
    return v;
  });
}

// ─── DETECÇÃO DE GÊNERO (replicada do seu fluxo) ────────────────────────────

const NOMES_FEMININOS = new Set([
  'ana','maria','julia','juliana','beatriz','fernanda','camila','amanda',
  'patricia','jessica','larissa','luciana','gabriela','mariana','rafaela',
  'isabela','carolina','leticia','vanessa','bruna','cristina','renata',
  'adriana','daniela','monica','viviane','simone','tatiane','claudia',
  'rosana','helena','alice','laura','luana','natalia','sabrina','priscila',
  'aline','alessandra','debora','elaine','fabiana','giovana','heloisa',
  'livia','lorena','nathalia','paola','raquel','sandra','silvia','vitoria',
  'yasmin','karina','kelly','leila','lilian','luiza','milena','mirela',
]);

const NOMES_MASCULINOS = new Set([
  'joao','jose','antonio','francisco','carlos','paulo','pedro','lucas',
  'luiz','marcos','gabriel','rafael','daniel','marcelo','mateus','matheus',
  'rodrigo','anderson','guilherme','eduardo','felipe','thiago','vinicius',
  'diego','bruno','alex','alexandre','andre','gustavo','henrique','igor',
  'leonardo','mario','miguel','nelson','renan','ronaldo','samuel','tiago',
  'caio','davi','elvis','fabricio','flavio','ivan','jefferson','jorge',
  'junior','lauro','murilo','pablo','sergio','vitor','washington','yuri',
]);

export function detectGender(fullName) {
  const first = fullName.split(' ')[0].toLowerCase();
  if (NOMES_FEMININOS.has(first)) return 'feminino';
  if (NOMES_MASCULINOS.has(first)) return 'masculino';
  return 'indefinido';
}
